var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.66664 599.99998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #c6c6c6;\n      isolation: isolate;\n      }\n\n      .cls-2 {\n      fill: #7c7c7c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "light",
    className: "cls-1",
    d: "M600,100H200c-73.66666,0-133.33333,59.33333-133.33333,132.33332V567.66667C66.66666,640.66662,126.33333,700,200,700H600c73.66663,0,133.33333-59.33335,133.33333-132.3333V232.33332C733.33331,159.33333,673.66661,100,600,100Z",
    transform: "translate(-66.66666 -100)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M674.97186,490.876H559.10843a25,25,0,0,1,0-50H674.97186a25,25,0,0,1,0,50Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M674.97186,373.90052H597.494a25,25,0,0,1,0-50h77.47789a25,25,0,0,1,0,50Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M674.97186,607.85138H508.3052a25,25,0,1,1,0-50H674.97186a25,25,0,1,1,0,50Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.93115,530.84042a92.45318,92.45318,0,1,1,92.45316-92.45319v0h0A92.45318,92.45318,0,0,1,308.93115,530.84042Zm0-179.09711a86.64394,86.64394,0,1,0,86.644,86.644h0a86.64393,86.64393,0,0,0-86.64392-86.644Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.93092,542.95932A104.57231,104.57231,0,1,1,413.50323,438.387,104.69045,104.69045,0,0,1,308.93092,542.95932Zm0-179.09661a74.525,74.525,0,1,0,74.525,74.52431A74.6088,74.6088,0,0,0,308.93092,363.86271Z",
    transform: "translate(-66.66666 -100)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.93115,442.46607a92.45318,92.45318,0,1,1,92.45316-92.4532v0h0A92.45319,92.45319,0,0,1,308.93115,442.46607Zm0-179.09711a86.64395,86.64395,0,1,0,86.644,86.64395h0A86.644,86.644,0,0,0,308.93119,263.369Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.93092,454.58532A104.57231,104.57231,0,1,1,413.50323,350.013,104.69046,104.69046,0,0,1,308.93092,454.58532Zm0-179.09727a74.52464,74.52464,0,1,0,74.525,74.525A74.60894,74.60894,0,0,0,308.93092,275.48805Z",
    transform: "translate(-66.66666 -100)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.93115,351.86692a92.45318,92.45318,0,1,1,92.45316-92.45319v0h0A92.45319,92.45319,0,0,1,308.93115,351.86692Zm0-179.09711a86.64395,86.64395,0,1,0,86.644,86.644,86.64394,86.64394,0,0,0-86.644-86.644h0Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.93092,363.98632A104.57231,104.57231,0,1,1,413.50323,259.414,104.69087,104.69087,0,0,1,308.93092,363.98632Zm0-179.09727a74.52464,74.52464,0,1,0,74.525,74.525A74.60894,74.60894,0,0,0,308.93092,184.88905Z",
    transform: "translate(-66.66666 -100)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.55229,396.85749a92.45317,92.45317,0,1,1,92.45319-92.45317,92.45317,92.45317,0,0,1-92.45319,92.45317Zm0-179.09711a86.64395,86.64395,0,1,0,86.64395,86.644,86.64393,86.64393,0,0,0-86.64395-86.644Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.55208,408.9768a104.57231,104.57231,0,1,1,104.5723-104.57231A104.69045,104.69045,0,0,1,386.55208,408.9768Zm0-179.09727a74.52463,74.52463,0,1,0,74.525,74.525A74.60893,74.60893,0,0,0,386.55208,229.87953Z",
    transform: "translate(-66.66666 -100)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.81068,487.45664a92.45317,92.45317,0,1,1,92.45315-92.45319v0h0A92.45317,92.45317,0,0,1,385.81068,487.45664Zm0-179.09711a86.64395,86.64395,0,1,0,86.644,86.644h0a86.64393,86.64393,0,0,0-86.644-86.64394Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.81041,499.57579a104.57231,104.57231,0,1,1,104.57231-104.5723A104.69045,104.69045,0,0,1,385.81041,499.57579Zm0-179.09726a74.52463,74.52463,0,1,0,74.525,74.525A74.60935,74.60935,0,0,0,385.81041,320.47853Z",
    transform: "translate(-66.66666 -100)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.05167,396.11588a92.45318,92.45318,0,1,1,92.45319-92.45317h0a92.45318,92.45318,0,0,1-92.45317,92.45317Zm0-179.09711a86.64394,86.64394,0,1,0,86.644,86.64395h0a86.644,86.644,0,0,0-86.64393-86.64395Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.05143,408.23513A104.57231,104.57231,0,1,1,336.62374,303.66282,104.69046,104.69046,0,0,1,232.05143,408.23513Zm0-179.09727a74.52464,74.52464,0,1,0,74.525,74.525A74.60892,74.60892,0,0,0,232.05143,229.13786Z",
    transform: "translate(-66.66666 -100)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.31006,486.71507a92.45317,92.45317,0,1,1,92.45315-92.4532v0h0A92.45316,92.45316,0,0,1,231.31006,486.71507Zm0-179.09711a86.64394,86.64394,0,1,0,86.64395,86.644h0a86.644,86.644,0,0,0-86.64391-86.644h0Z",
    transform: "translate(-66.66666 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.30976,498.83413A104.57231,104.57231,0,1,1,335.88207,394.26182,104.69045,104.69045,0,0,1,231.30976,498.83413Zm0-179.09727a74.52464,74.52464,0,1,0,.00066,0Z",
    transform: "translate(-66.66666 -100)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.35192aaf.svg";
export { ForwardRef as ReactComponent };